import { createContext } from "react";
import { diagnosticReportViewOptions } from "../constants/diagnosticReport";
import { SolutionDiagnosticsOption } from "../views/GeneralTask/generalTask.types";
import { parentViewsOptions } from "../constants/parentFault";
import { PlotOption, mfdPlotOptions, namedFaultsOptions } from "../constants/nameFaultsMfds";

export const initState = {
  favouriteIdArray: [],
  setFavouriteIdArray: () => {},
  viewOptions: [diagnosticReportViewOptions[0]],
  setViewOptions: () => {},
  generalViewSelections: [diagnosticReportViewOptions[0]],
  setGeneralViewSelections: () => {},
  generalViews: [diagnosticReportViewOptions[0].displayName],
  setGeneralViews: () => {},
  parentFaultViews: [parentViewsOptions[0].displayName],
  setParentFaultViews: () => {},
  parentFault: "",
  setParentFault: () => {},
  namedFaultsView: mfdPlotOptions[0].displayName,
  setNamedFaultsView: () => {},
  namedFaultsLocations: [namedFaultsOptions[0].displayName],
  setNamedFaultsLocations: () => {},
  mfdPlotSelection: mfdPlotOptions[0],
  setMfdPlotSelection: () => {},
};

export type LocalStorageContextState = {
  favouriteIdArray: string[] | null;
  setFavouriteIdArray: (newValue: string[]) => void;
  viewOptions: SolutionDiagnosticsOption[];
  setViewOptions: (newValue: SolutionDiagnosticsOption[]) => void;
  generalViewSelections: SolutionDiagnosticsOption[];
  setGeneralViewSelections: (newValue: SolutionDiagnosticsOption[]) => void;
  generalViews: string[];
  setGeneralViews: (newValue: string[]) => void;
  parentFaultViews: string[];
  setParentFaultViews: (newValue: string[]) => void;
  parentFault: string;
  setParentFault: (newValue: string) => void;
  namedFaultsView: string;
  setNamedFaultsView: (newValue: string) => void;
  namedFaultsLocations: string[];
  setNamedFaultsLocations: (newValue: string[]) => void;
  mfdPlotSelection: PlotOption;
  setMfdPlotSelection: (newValue: PlotOption) => void;
};

const LocalStorageContext = createContext<LocalStorageContextState>(initState);

export default LocalStorageContext;
